'use client';

import { dynamicComponents } from '@tuic/ui-kit/icons';
import { twJoin, twMerge } from 'tailwind-merge';
import React from 'react';
export type LegacyIconName = keyof typeof dynamicComponents;
type IconElement = React.ReactElement | null;
export type LegacyIconProps = {
  name: LegacyIconName;
  width?: number | string;
  height?: number | string;
  size?: number | string;
  className?: string;
};
const getDimensions = ({
  size,
  width = 24,
  height = 24
}: LegacyIconProps) => {
  if (size) {
    return {
      width: size,
      height: size
    };
  }
  return {
    width,
    height
  };
};

/**
 * Renders an icon.
 *
 * ```ts
 * import Icon  from '@tuic/web-compositions/shared/LegacyIcon';
 *
 * const MyComponent = () => {
 *   return (
 *     <div>
 *       <Icon name="report" />
 *     </div>
 *   )
 * };
 *
 * export default MyComponent;
 * ```
 *
 */
export const LegacyIcon = (props: LegacyIconProps): IconElement => {
  const {
    className,
    name,
    ...rest
  } = props;
  const isSpecialFill = name === 'mein-schiff-7' || name === 'mein-schiff-relax';
  const iconProps = {
    ...getDimensions(props),
    viewBox: '0 0 24 24'
  };

  // if (typeof window === 'undefined') return <></>;
  const Icon = dynamicComponents[name];
  if (!Icon) <></>;
  return <div className={twMerge(twJoin('pointer-events-none flex items-center justify-center [&>svg]:fill-[currentColor] [&_>_svg_>_path]:fill-[currentColor]', !isSpecialFill && '[&_path]:fill-[currentColor]', isSpecialFill && '[&_path:not([fill="#FFF374"])]:fill-[currentColor]', className))} {...rest as any} data-sentry-component="LegacyIcon" data-sentry-source-file="LegacyIcon.tsx">
      <Icon {...iconProps} data-sentry-element="Icon" data-sentry-source-file="LegacyIcon.tsx" />
    </div>;
};